// LoadingSpinner.jsx
import React from "react";
import { ClipLoader } from "react-spinners"; // 원하는 스피너 컴포넌트를 임포트합니다.

const LoadingSpinner = ({ loading }) => {
  return (
    <div className="loading-spinner">
      <ClipLoader color="#36D7B7" loading={loading} size={150} />
    </div>
  );
};

export default LoadingSpinner;
